export const Himatnagar = {
    title: "Himatnagar",
    title1: "(Historical)",

    attractions: [
        {
            name: "Shamlaji Temple",
            description: "Shamlaji Temple, dedicated to Lord Vishnu, is one of the prominent pilgrimage sites in Himatnagar. The temple is known for its intricate architecture and serene surroundings, attracting thousands of devotees every year.",
            location: "Shamlaji, Himatnagar, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Attend religious ceremonies",
                "Explore the temple's intricate carvings",
                "Enjoy the peaceful surroundings",
                "Participate in local festivals like Shamlaji Fair"
            ],
            mapLink: "https://maps.app.goo.gl/X4a9A4Wxh9XyFHGk8",
        },
        {
            name: "Himatnagar Fort",
            description: "The Himatnagar Fort, a historical fort built in the 18th century, reflects the rich heritage of the region. It is a testament to the grandeur of the erstwhile rulers and their contribution to the town's history.",
            location: "Himatnagar, Gujarat",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Late Afternoon",
            activities: [
                "Explore the ancient fort walls",
                "Learn about the history of the region",
                "Capture photographs of the scenic views"
            ],
            mapLink: "https://maps.app.goo.gl/XyWXYw7nJ5wV7kzFA",
        },
        {
            name: "Juna Gav",
            description: "Juna Gav is a historical village known for its old temples and cultural significance. The village has numerous ancient shrines that are still visited by locals and pilgrims seeking blessings.",
            location: "Juna Gav, Near Himatnagar, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Visit the historical temples",
                "Explore the village and interact with locals",
                "Attend local festivals"
            ],
            mapLink: "https://maps.app.goo.gl/QdV2JgMv6RVsfgVu5",
        },
        {
            name: "Sankheda",
            description: "Sankheda is a famous town known for its wooden furniture and traditional craftsmanship. The town is also home to several temples and is a great place to experience local culture and traditions.",
            location: "Sankheda, Himatnagar, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Shop for traditional wooden furniture",
                "Explore local temples",
                "Engage in cultural experiences"
            ],
            mapLink: "https://maps.app.goo.gl/9C2dV5Cw6CxDPszY9",
        },
        {
            name: "Brahmani Mata Temple",
            description: "Dedicated to Goddess Brahmani, this temple is one of the important spiritual centers in Himatnagar. The temple attracts thousands of devotees, especially during Navratri.",
            location: "Brahmani Mata Temple, Himatnagar, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Participate in religious rituals",
                "Enjoy the peaceful atmosphere",
                "Visit during festivals like Navratri"
            ],
            mapLink: "https://maps.app.goo.gl/K1gWLkYrBhD9X4wE7",
        },
        {
            name: "Ranchhodrai Dakor Temple",
            description: "Situated near Himatnagar, this temple is dedicated to Lord Krishna and is known for its vibrant architecture and spiritual significance. It's a famous pilgrimage site for Hindus.",
            location: "Ranchhodrai Temple, Dakor, Near Himatnagar, Gujarat",
            timings: "5:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the temple's beautiful architecture",
                "Attend religious ceremonies",
                "Participate in the temple's cultural activities"
            ],
            mapLink: "https://maps.app.goo.gl/L5HNmzV1rHwX5tPt9",
        },
        {
            name: "Jain Derasar",
            description: "A peaceful Jain temple in Himatnagar, known for its beautiful architecture and serene ambiance. It's a place of worship and tranquility.",
            location: "Jain Derasar, Himatnagar, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend Jain rituals",
                "Explore the peaceful temple premises",
                "Meditate in the serene environment"
            ],
            mapLink: "https://maps.app.goo.gl/ymFQ3b8gV9dDt8w88",
        },
        {
            name: "Himmatnagar Lake",
            description: "This serene lake is a popular spot for locals to relax and unwind. It is surrounded by lush greenery, making it an ideal spot for a peaceful afternoon.",
            location: "Himmatnagar, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Enjoy a peaceful walk",
                "Relax by the lake",
                "Photography of the scenic views"
            ],
            mapLink: "https://maps.app.goo.gl/cRxzUzo3Zb68sYPb7",
        },
        {
            name: "Ambaji Temple",
            description: "Located near Himatnagar, Ambaji Temple is one of the 51 Shakti Peethas and is dedicated to Goddess Amba. It is a highly revered site for pilgrims.",
            location: "Ambaji, Near Himatnagar, Gujarat",
            timings: "5:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Participate in religious rituals",
                "Explore the temple complex",
                "Attend the Ambaji Fair"
            ],
            mapLink: "https://maps.app.goo.gl/7smqKr4i4KtsFZ7u9",
        },
        {
            name: "Sankalchand Patel College of Engineering",
            description: "An educational institution in Himatnagar, known for its academic excellence. It is also an architectural marvel in the region.",
            location: "Sankalchand Patel College, Himatnagar, Gujarat",
            timings: "9:00 AM to 5:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Throughout the year",
            activities: [
                "Explore the college's architectural design",
                "Attend academic seminars or workshops"
            ],
            mapLink: "https://maps.app.goo.gl/G5Z9c5jUSkVQkvUVA",
        },
        {
            name: "Rani Ki Vav (Stepwell)",
            description: "Although not in Himatnagar directly, this UNESCO World Heritage Site is located nearby in Patan. It’s an ancient stepwell built in the 11th century, known for its intricate carvings and architectural brilliance.",
            location: "Rani Ki Vav, Patan, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the stepwell",
                "Photography of the carvings and structure",
                "Learn about the history of the stepwell"
            ],
            mapLink: "https://maps.app.goo.gl/fxTktSYyGFM68v9X6",
        },
        {
            name: "Kadi Vav",
            description: "Another historical stepwell located in the vicinity of Himatnagar, known for its architecture and design.",
            location: "Kadi Vav, Near Himatnagar, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Photography",
                "Explore the ancient stepwell structure"
            ],
            mapLink: "https://maps.app.goo.gl/x3XYaJmHnR8uF6dP8",
        },
        {
            name: "Himatnagar Zoo",
            description: "A small zoo in Himatnagar that houses a variety of local and exotic species. It is an ideal place for families to spend time together.",
            location: "Himatnagar Zoo, Himatnagar, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore different animal species",
                "Take a guided tour",
                "Photography"
            ],
            mapLink: "https://maps.app.goo.gl/t8vGBKZCj9d5bYsW9",
        }
    ]
};
